import { Color } from "../generated/models_pb";

export class TerrainGrid {
  public id?: string;
  public cols!: number;
  public rows!: number;
  public cellsize!: number;
  public lowerleftx!: number;
  public lowerlefty!: number;
  public cellsList!: Array<Cell>;
}

export class Cell {
  public hillshade!:number;
  public color?: Color.AsObject;
}

